import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useAuthToken } from "./useAuthToken";
import { usePushNotification } from "./usePushNotification";
import { useLoginMutation, useMeLazyQuery, useMeQuery } from "../graphql";

export const useLogin = () => {
    const { i18n } = useTranslation();
    const history = useHistory();
    const { token, setAuthToken, setAccountId, setRole } = useAuthToken();

    const [getMe, { data }] = useMeLazyQuery({
        fetchPolicy: "network-only"
    });

    useEffect(() => {
        if (data?.me?.id) {
            setAccountId(data.me.id);
            setRole(data.me.role);

            localStorage.setItem("user-language", data.me.language.code);
            i18n.changeLanguage(data.me.language.code);
            history.push("/home");
        }
    }, [data, history, i18n, setAccountId, setRole]);

    const [mutation, mutationResults] = useLoginMutation({
        onCompleted: async (data) => {
            // @ts-ignore
            setAuthToken(data.login.token);
            await getMe();
        }
    });

    //we have rewritten the function to have a cleaner interface
    const login = (email, password, tfaCode) => {
        return mutation({
            variables: {
                email,
                password,
                tfaCode
            }
        });
    };

    return [login, mutationResults];
};
